// test326
(326 && 0);
